<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="isShow"
    width="760px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :z-index="9001"
    @close="isShow = false"
  >
    <el-form
      :model="JZForm"
      ref="JZForm"
      :rules="isViewMode ? {} : rules"
      label-width="100px"
      label-position="right"
      style="padding-top: 8px; padding-bottom: 40px;"
    >
      <el-row>
        <!-- 属性名称 -->
        <el-col :span="24">
          <el-form-item label="属性名称" prop="name">
            <el-input placeholder="请输入属性名称" v-model.trim="JZForm.name" maxlength="200" show-word-limit clearable :disabled="isViewMode"></el-input>
          </el-form-item>
        </el-col>

        <!-- 属性备注 -->
        <el-col :span="24">
          <el-form-item label="属性备注">
            <el-input placeholder="请输入属性备注" v-model.trim="JZForm.remark" maxlength="200" show-word-limit clearable :disabled="isViewMode"></el-input>
          </el-form-item>
        </el-col>

        <!-- 属性值类型（新） -->
        <el-col :span="24">
          <el-form-item label="属性值类型" prop="valueType">
            <el-radio-group v-model="JZForm.valueType" @change="handleValueTypeChange" :disabled="isViewMode">
              <el-radio label="SINGLE">单选</el-radio>
              <el-radio label="MULTI">多选</el-radio>
              <el-radio label="CUSTOM">自定义输入</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <!-- 单选/多选：候选值列表 -->
        <template v-if="JZForm.valueType === 'SINGLE' || JZForm.valueType === 'MULTI'">
          <el-col :span="24">
            <el-form-item label="属性候选值">
              <div>
                <el-button v-if="!isViewMode" size="mini" type="primary" @click="addValueRow">新增行</el-button>
                <el-table :data="JZForm.valueList" border size="small" style="margin-top:8px;">
                  <el-table-column label="属性值" min-width="180">
                    <template slot-scope="{ row }">
                      <span v-if="isViewMode">{{ row.optionValue || '--' }}</span>
                      <el-input v-else v-model.trim="row.optionValue" maxlength="20" show-word-limit size="small" placeholder="请输入属性值"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="是否默认" width="90" align="center">
                    <template slot-scope="{ row, $index }">
                      <el-checkbox v-model="row.isDefault" @change="handleDefaultChange($index)" :disabled="isViewMode"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="!isViewMode" label="操作" width="80" align="center">
                    <template slot-scope="{ $index }">
                      <el-button type="text" size="mini" @click="removeValueRow($index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-col>
        </template>

        <!-- 自定义输入：属性值规则 -->
        <template v-if="JZForm.valueType === 'CUSTOM'">
          <el-col :span="24">
            <el-form-item label="属性值规则" prop="valueRule">
              <el-radio-group v-model="JZForm.valueRule" @change="handleValueRuleChange" :disabled="isViewMode">
                <el-radio label="SHORT_TEXT">短文本</el-radio>
                <el-radio label="TEXT_AREA">文本域</el-radio>
                <el-radio label="TIME">时间</el-radio>
                <el-radio label="NUM">数值</el-radio>
                <el-radio label="FILE">附件</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!-- 是否有单位（数值） -->
          <template v-if="JZForm.valueRule === 'NUM'">
            <el-col :span="12">
              <el-form-item label="是否有单位">
                <el-radio-group v-model="JZForm.hasUnitFlag" :disabled="isViewMode">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="JZForm.hasUnitFlag">
              <el-form-item label="单位" prop="unitName">
                <el-select v-model="JZForm.unitName" placeholder="请选择单位" filterable :disabled="isViewMode">
                  <el-option v-for="item in unitOptions" :key="item.name" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <!-- 数值：区间 + 小数位 -->
          <template v-if="JZForm.valueRule === 'NUM'">
            <el-col :span="12">
              <el-form-item label="是否区间">
                <el-radio-group v-model="JZForm.isRange" :disabled="isViewMode">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小数位数">
                <el-select v-model="JZForm.decimalPlaces" :disabled="isViewMode">
                  <el-option v-for="n in [0,1,2,3,4]" :key="n" :label="n" :value="n"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <!-- 时间：区间 + 精度 -->
          <template v-if="JZForm.valueRule === 'TIME'">
            <el-col :span="12" key="time-isRange">
              <el-form-item label="是否区间">
                <el-radio-group v-model="JZForm.isRange" :disabled="isViewMode">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" key="time-precision">
              <el-form-item label="时间精度" prop="timePrecision">
                <el-select v-model="JZForm.timePrecision" placeholder="请选择时间精度" :disabled="isViewMode">
                  <el-option v-for="item in timePrecisionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <!-- 附件：类型 + 大小 -->
          <template v-if="JZForm.valueRule === 'FILE'">
            <el-col :span="24" key="file-type">
              <el-form-item label="附件类型">
                <el-select v-model="JZForm.attachmentTypeList" multiple placeholder="请选择允许的附件类型" style="width:100%;" :disabled="isViewMode">
                  <el-option v-for="t in attachmentTypeOptions" :key="t" :label="t" :value="t"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" key="file-size">
              <el-form-item label="大小限制">
                <el-select v-model="JZForm.attachmentSize" :disabled="isViewMode">
                  <el-option label="<10M（系统默认）" :value="10"></el-option>
                  <el-option label="<20M" :value="20"></el-option>
                  <el-option label="<50M" :value="50"></el-option>
                  <el-option label="<100M" :value="100"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
        </template>

      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <template v-if="isViewMode">
        <el-button @click="isShow=false">关 闭</el-button>
      </template>
      <template v-else>
        <el-button @click="isShow=false">取 消</el-button>
        <el-button @click="handleSubmit" type="primary">{{ currentId ? '更 新' : '保 存' }}</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { addAttribute, updateAttribute, detailAttribute } from '@/api/PlatformSales/ProductAttributes';
import { getGoodsUnitLists } from '@/api/PlatformSales/MeasurementUnit';

export default {
  name: 'EditAttribute',
  methods: {
    initPage () {
      this.isShow = true;
      this.getUnitLists();
      if (this.currentId) {
        this.getDetailInfo();
      } else {
        this.$nextTick(() => this.$refs.JZForm && this.$refs.JZForm.clearValidate());
      }
    },
    getDetailInfo () {
      if (!this.currentId) return;
      detailAttribute({ id: this.currentId }).then(({ body }) => {
        const attachmentTypeList = body.attachmentTypes ? body.attachmentTypes.split(',') : [];
        this.JZForm = {
          name: body.name || '',
          remark: body.remark || '',
          valueType: body.valueType || '',
          valueRule: body.valueRule || '',
          hasUnitFlag: body.hasUnitFlag || false,
          unitName: body.unitName || '',
          timePrecision: body.timePrecision || '',
          isRange: body.isRange || false,
          decimalPlaces: body.decimalPlaces != null ? body.decimalPlaces : 2,
          attachmentTypeList,
          attachmentSize: body.attachmentSize || 10,
          attributeCategoryId: body.attributeCategoryId || '',
          valueList: (body.valueList || []).map(v => ({ ...v })),
        };
        this.$nextTick(() => this.$refs.JZForm && this.$refs.JZForm.clearValidate());
      });
    },
    handleValueTypeChange () {
      if (this.JZForm.valueType === 'SINGLE') {
        let foundDefault = false;
        this.JZForm.valueList.forEach(v => {
          if (v.isDefault) {
            if (foundDefault) v.isDefault = false;
            else foundDefault = true;
          }
        });
      }
    },
    handleValueRuleChange () {
      this.JZForm.isRange = false;
      this.JZForm.decimalPlaces = 2;
      this.JZForm.timePrecision = '';
      this.JZForm.attachmentTypeList = [];
      this.JZForm.attachmentSize = 10;
    },
    addValueRow () {
      this.JZForm.valueList.push({ optionValue: '', isDefault: false, sort: this.JZForm.valueList.length });
    },
    removeValueRow (index) {
      this.JZForm.valueList.splice(index, 1);
    },
    handleDefaultChange (index) {
      // 单选时只允许一个默认值
      if (this.JZForm.valueType === 'SINGLE') {
        this.JZForm.valueList.forEach((v, i) => {
          if (i !== index) v.isDefault = false;
        });
      }
    },
    handleSubmit () {
      this.$refs.JZForm.validate((valid) => {
        if (!valid) return;
        const attachmentTypes = (this.JZForm.attachmentTypeList || []).join(',');
        const params = {
          ...this.JZForm,
          attachmentTypes,
          id: this.currentId,
          valueList: this.JZForm.valueList.filter(v => v.optionValue),
        };
        delete params.attachmentTypeList;
        const api = this.currentId ? updateAttribute : addAttribute;
        api(params).then(() => {
          this.isShow = false;
          if (!this.currentId && this.$route.query.isAddAttribute) {
            this.$tabs.close({ to: this.$route.query.fullPath, refresh: true });
          }
          this.$emit('handleReset');
        });
      });
    },
    getUnitLists () {
      getGoodsUnitLists({ pageFlag: false }).then(({ body }) => {
        this.unitOptions = body.list || [];
      });
    },
  },
  computed: {
    rules () {
      return {
        name: [{ required: true, message: '请输入属性名称', trigger: ['blur', 'change'] }],
        valueType: [{ required: true, message: '请选择属性值类型', trigger: ['blur', 'change'] }],
        valueRule: [{ required: this.JZForm.valueType === 'CUSTOM', message: '请选择属性值规则', trigger: ['blur', 'change'] }],
        timePrecision: [{ required: this.JZForm.valueRule === 'TIME', message: '请选择时间精度', trigger: ['blur', 'change'] }],
      };
    },
  },
  data () {
    return {
      isShow: false,
      currentId: '',
      isViewMode: false,
      dialogTitle: '添加属性',
      timePrecisionList: [
        { label: '年', value: '年' },
        { label: '月', value: '月' },
        { label: '天', value: '天' },
        { label: '秒', value: '秒' },
      ],
      attachmentTypeOptions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'csv', 'pdf', 'docx', 'xls', 'xml'],
      unitOptions: [],
      JZForm: {
        name: '',
        remark: '',
        valueType: '',
        valueRule: '',
        hasUnitFlag: false,
        unitName: '',
        timePrecision: '',
        isRange: false,
        decimalPlaces: 2,
        attachmentTypeList: [],
        attachmentSize: 10,
        attributeCategoryId: '',
        valueList: [],
      },
    };
  },
};
</script>

<style scoped lang='scss'>
/deep/ .el-dialog__header {
  padding-top: 0;
  border-bottom: 1px solid #E4E7ED;
  display: flex;
  align-items: center;
  height: 40px;
}

/deep/ .el-dialog__body {
  padding-top: 8px;
  max-height: 65vh;
  overflow-y: auto;
}

/deep/ .el-dialog__footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 1;
  border-top: 1px solid #E4E7ED;
}
</style>
